import dayjs from 'dayjs';

interface ContentListItemProps {
  title: string;
  createdAt: string;
  onCopy: () => void;
  onEdit: () => void;
}

const ContentListItem = ({
  title,
  createdAt,
  onCopy,
  onEdit,
}: ContentListItemProps) => {
  return (
    <div
      className="flex items-center gap-4 py-3 px-4 rounded-lg transition-all hover:bg-CoolGray-50 cursor-pointer"
      onClick={onEdit}
    >
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm leading-[18px] text-[#506073]">
          {title}
        </p>
      </div>

      <div className="flex shrink-0 gap-2">
        {/* 최초 작성일 */}
        <div className="w-[96px] flex items-center justify-center">
          <span className="text-sm  text-CoolGray-800">
            {dayjs(createdAt).format('YYYY.MM.DD')}
          </span>
        </div>
        {/* 복사하기 버튼 */}
        <button
          onClick={e => {
            e.stopPropagation();
            onCopy();
          }}
          className="flex h-[34px] w-[76px] items-center justify-center rounded-md border border-[#DFDFDF] bg-white transition-all hover:bg-gray-50"
        >
          <span className="text-sm font-bold leading-[18px] text-[#2C3744]">
            복사하기
          </span>
        </button>

        {/* 수정하기 버튼 */}
        <button
          onClick={onEdit}
          className="flex h-[34px] w-[76px] items-center justify-center rounded-md bg-[#FFED49] shadow-sm transition-all hover:bg-[#FFE91F]"
        >
          <span className="text-sm font-bold leading-[18px] text-[#2C3744]">
            수정하기
          </span>
        </button>
      </div>
    </div>
  );
};

export default ContentListItem;
